"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { usePageTransition } from "@/components/page-transition-provider";
import { loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
export function useClientsAnimation(containerRef) {
  const $ = _c(4);
  const {
    isTransitioning
  } = usePageTransition();
  let t0;
  let t1;
  if ($[0] !== containerRef || $[1] !== isTransitioning) {
    t0 = () => {
      if (shouldReduceMotion() || !containerRef.current || isTransitioning) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap,
          ScrollTrigger
        } = await loadGsapWithScrollTrigger();
        if (cancelled) {
          return;
        }
        const ctx = gsap.context(() => {
          const cards = gsap.utils.toArray(".logo-card", containerRef.current);
          if (!cards.length) {
            return;
          }
          gsap.fromTo(cards, {
            opacity: 0,
            y: 40,
            scale: 0.96,
            filter: "blur(10px)"
          }, {
            opacity: 1,
            y: 0,
            scale: 1,
            filter: "blur(0px)",
            duration: 2.2,
            ease: "power4.out",
            stagger: 0.12,
            clearProps: "filter",
            scrollTrigger: {
              trigger: containerRef.current,
              start: "top 90%",
              toggleActions: "play reverse restart reverse"
            }
          });
        }, containerRef);
        ScrollTrigger.refresh();
        cleanup = () => ctx.revert();
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [containerRef, isTransitioning];
    $[0] = containerRef;
    $[1] = isTransitioning;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}